/** Mirrors the API default Storage:MaxUploadBytes (10 MB). The server re-checks every upload; this only saves a round trip. */
export const MAX_UPLOAD_MB = 10;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

export const DOCUMENT_ACCEPT = ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png";
export const PHOTO_ACCEPT = ".jpg,.jpeg,.png,image/jpeg,image/png";

const documentTypes = new Set(["application/pdf", "image/jpeg", "image/png"]);
const photoTypes = new Set(["image/jpeg", "image/png"]);

/** A quick client-side pre-check by the browser's media type; the API decides by the file's actual bytes. */
export function looksAcceptable(file: File, imagesOnly: boolean): boolean {
  return (imagesOnly ? photoTypes : documentTypes).has(file.type);
}

/**
 * The generated client types a multipart body as its form schema, but the browser must send a FormData so it can
 * set the boundary. openapi-fetch passes a FormData through unchanged, so the value is only re-typed here.
 */
export function multipart<T>(fields: Record<string, string | Blob>): T {
  const data = new FormData();
  for (const [name, value] of Object.entries(fields)) data.append(name, value);
  return data as unknown as T;
}

/** Offers a downloaded blob to the user under the given file name. */
export function saveBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
